import { Route } from '@angular/router';
import { authGuard, STAFF_ROLES } from '@nebalkon-workspace/auth';
import { roleGuard, guestOnlyGuard, initialRedirectGuard } from './guards';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    canMatch: [initialRedirectGuard],
    loadComponent: () =>
      import('./guards/').then((m) => m.RootRedirectComponent),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./features/onboarding/onboarding.routes').then(
        (r) => r.onboardingRoutes,
      ),
    canMatch: [guestOnlyGuard()],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((r) => r.authRoutes),
    canMatch: [guestOnlyGuard()],
  },
  {
    path: 'stuff',
    loadChildren: () =>
      import('./features/dashboard/dashboard.routes').then(
        (r) => r.dashboardRoutes,
      ),
    canMatch: [authGuard(), roleGuard({ allowedRoles: STAFF_ROLES })],
  },
  {
    path: 'client',
    loadChildren: () =>
      import('./features/client/client.routes').then((r) => r.clientRoutes),
    canMatch: [authGuard()],
    data: { redirectPath: '/auth' },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
